export const UPDATE_TABLE_STATE = 'UPDATE_TABLE_STATE';
export const BILLING_UI_RELEASE_YEAR = 2022;
export const BILLING_UI_RELEASE_MONTH = '06';
export const BILLING_UI_RELEASE_MONTH_LABEL = 'June';

export const DEFAULT_RELEASED_DATE = `${BILLING_UI_RELEASE_YEAR}-${BILLING_UI_RELEASE_MONTH}-01`;

export const LOCAD_STAFF_PERMISSION = 'LOCAD_STAFF';
